import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=b45bdc3e&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports